export class DateSubmitProcessor {
        static convertDateToBackend(date) {
            if (!date) {
                return '';
            }
            let dateParts = date.split('-');
            let dateObject = [dateParts[2], dateParts[1], dateParts[0]];
            return dateObject.join('-');
        }

        static prepareDateBackend(date, time) {
            if (!date) {
                return null;
            }
            if (!time) {
                time = '00:00:00'
            }
            date = DateSubmitProcessor.convertDateToBackend(date);
            return `${date}T${time}`;
        }


        static convertDateToNative(date) {
            if (!date) {
                return '';
            }
            let dateParts = date.split('.');
            let dateObject = [dateParts[2], dateParts[1], dateParts[0]];
            return dateObject.join('-');
        }

        static convertDateToLocal(date) {
            if (!date) {
                return null;
            }
            let dateParts = date.split('-');
            if (dateParts.length === 3) {
                let dateObject = [dateParts[2], dateParts[1], dateParts[0]];
                return dateObject.join('.');
            }
            return date
        }

        static appendDefaultTime(date) {
            if (!date) {
                return null;
            }
            const time = '00:00:00';
            return `${date} ${time}`;
        }

        static prepareDate(date, time) {
            if (!date) {
                return null;
            }
            if (!time) {
                time = '00:00:00'
            }
            date = DateSubmitProcessor.convertDateToLocal(date);
            return `${date} ${time}`;
        }
}


export const todayStr = function () {
    function _addLeadingZero(str) {
        return ("0" + str).slice(-2);
    }

    const today = new Date();
    const hours = _addLeadingZero(today.getHours());
    const minutes = _addLeadingZero(today.getMinutes());
    const seconds = _addLeadingZero(today.getSeconds());
    const day = _addLeadingZero(today.getDate());
    const month = _addLeadingZero(today.getMonth() + 1);
    const year = today.getFullYear();
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
};
